<div class="isg-menuv-container">
  <nav class="isg-menuv-nav">
    <ul class="isg-menuv" role="menu" aria-orientation="vertical">

      <ng-container [ngTemplateOutlet]="templateMenuVertical"
                    [ngTemplateOutletContext]="{ items : menuItems, level: 1 }">

      </ng-container>

    </ul>
  </nav>
</div>

<ng-template #templateMenuVertical let-items="items" let-level="level">

  <ng-container *ngFor="let item of items">

    <ng-container *ngIf="item.hasChildren">
      <ng-container [ngTemplateOutlet]="showChildren"
                    [ngTemplateOutletContext]="{ item: item, level: level }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!item.hasChildren">
      <ng-container [ngTemplateOutlet]="elseNoChildren"
                    [ngTemplateOutletContext]="{ item: item, level: level }">
      </ng-container>
    </ng-container>

  </ng-container>

</ng-template>

<ng-template #showChildren let-item="item" let-level="level">
  <li role="menuitem" class="isg-mitem-haschildren"
      attr.level="{{assignLevel(item, level)}}"
      [ngClass]="{'isg-mitem-top': level == 1, 'isg-mitem-expanded': item.expanded, 'isg-mitem-expanded-current' : item.currExpanded , 'selected': item.selected}"
      attr.aria-label="{{item.name}}">
    <div *ngIf="level == 1" class="isg-mitem-content">
      <span [ngClass]="getImageClass(item)"></span>
      <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
      <span class="k-spacer"></span>
      <span class="k-icon"></span>
    </div>
    <!-- A real button, not a div with a click handler. As a div this was absent
         from the accessibility tree and unreachable by keyboard, so a collapsed
         group could not be opened without a mouse. -->
    <button *ngIf="level > 1"
            type="button"
            class="isg-mitem-content isg-mitem-toggle"
            [attr.aria-expanded]="!!item.expanded"
            [attr.aria-controls]="'isg-menu-children-' + item.id"
            (click)="toggleSubmenu($event, item)">
      <span [ngClass]="getImageClass(item)"></span>
      <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
      <span class="k-spacer"></span>
      <span class="fa-solid" [ngClass]="{'fa-chevron-down': item.expanded, 'fa-chevron-right': !item.expanded}"></span>
    </button>
    <ul role="menu"
        class="isg-mitem-children"
        [attr.id]="'isg-menu-children-' + item.id"
        [ngClass]="{'hidden' : !item.expanded && level > 1 }">
      <ng-container [ngTemplateOutlet]="templateMenuVertical"
                    [ngTemplateOutletContext]="{ items : item.children , level: level + 1 }">
      </ng-container>
    </ul>
  </li>
</ng-template>

<ng-template #elseNoChildren let-item="item" let-level="level">
  <li role="menuitem"
      [ngClass]="{'isg-mitem-top': level == 1, 'isg-mitem-bookmark': isBookmark(item), 'selected': item.selected }"
      attr.level="{{assignLevel(item, level)}}"
      attr.aria-label="{{item.name}}">
    <ng-container *ngIf="!(item.url) || item.url.length < 1">
      <ng-container [ngTemplateOutlet]="noRoute"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(item.url) && item.url.length > 0 && isItemRouteSupport(item.url)">
      <ng-container [ngTemplateOutlet]="routeSupport"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(item.url) && item.url.length > 0 && isItemRouteHelp(item.url)">
      <ng-container [ngTemplateOutlet]="routeHelp"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(item.url) && item.url.length > 0 && !isItemRouteSupport(item.url) && !isItemRouteHelp(item.url) && isItemRouteInternal(item.url)">
      <ng-container [ngTemplateOutlet]="routeInternal"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(item.url) && item.url.length > 0 && !isItemRouteSupport(item.url) && !isItemRouteHelp(item.url) && !isItemRouteInternal(item.url)">
      <ng-container [ngTemplateOutlet]="routeExternal"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>
  </li>
</ng-template>
 
<ng-template #noRoute let-item="item">
  <div class="isg-mitem-content" >
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </div>
</ng-template>

<ng-template #routeInternal let-item="item">
  <a class="isg-mitem-content" routerLink="{{item.url}}" >
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </a>
</ng-template>

<!-- Help. A real href, so it looks like a link, is keyboard reachable, and honours
     ctrl-click and middle-click natively. No routerLink, deliberately: routerLink also
     handles click, and having two handlers race over one anchor is how this kind of
     thing breaks later. The plain click is taken over so Help opens in its own tab -
     see isItemRouteHelp for why Help and nothing else. -->
<ng-template #routeHelp let-item="item">
  <a class="isg-mitem-content" href="{{item.url}}"
     (click)="onHelpItemClick($event, item.url)">
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </a>
</ng-template>

<!-- Contact Support. A modal, not a page: the reader is usually mid-task and a form
     that takes thirty seconds should not cost them their place. The href is the Contact
     Support section in Help, so ctrl-click and middle-click still lead somewhere real -
     only the plain click is taken over. -->
<ng-template #routeSupport let-item="item">
  <a class="isg-mitem-content" href="{{item.url}}"
     (click)="onSupportItemClick($event)">
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </a>
</ng-template>

<ng-template #routeExternal let-item="item">
  <a class="isg-mitem-content" href="{{item.url}}" target="{{item.target}}">
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </a>
</ng-template>



